export class Period {
  constructor(init: Partial<Period> = {}) {
    this.dateFrom = init.dateFrom
    this.dateTo = init.dateTo
  }

  dateFrom?: Date
  dateTo?: Date
}
